export const Environment = {
    BASE_URL: process.env.REACT_APP_BASE || 'http://localhost:3015',
    API_URL: process.env.REACT_APP_API || 'http://localhost:3015',
    DOMAIN: process.env.REACT_APP_DOMAIN || 'http://localhost:3015',
    PORT: process.env.REACT_APP_PORT || '3020',
    API_KEY: process.env.REACT_APP_API_KEY || '',
};
